import {isURLPhoneOrMail} from './replaceURLForPhoneOrMail';

const isExternalUrlForDomain = domain => url =>
  url.match(`^https?\\:\\/\\/(?!(?:${domain}))([^\\/:?#]+)(?:[\\/:?#]|$)`, 'i') !== null || isURLPhoneOrMail(url);

export {isExternalUrlForDomain};

export default isExternalUrlForDomain(process.env.REACT_APP_HOST_DOMAIN);
